// Libraries
import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

// Use
import { useDesktop } from 'use/media'

// Components
import Row from 'ui/Row'
import Col from 'ui/Col'
import Text from 'ui/Text'
import Loading from 'ui/Loading'

// Styles
import './Media.scss'

function Media({
  title,
  description,
  round,
  alignIcon,
  icon,
  loading,
  className,
  ...props
}) {
  const isDesktop = useDesktop()
  const classList = useMemo(() => {
    const classes = [className, 'media-wrapper']

    if (props.onClick) {
      classes.push('--clickable')
    }
    if (round) {
      classes.push('--round')
    }

    return classes.join(' ')
  }, [className, props.onClick, round])

  return (
    <div className={classList} {...props}>
      <Loading spinning={loading}>
        <Row>
          <Col
            xs={3}
            sm={{ narrow: true }}
            className="__image-wrapper"
            style={{ alignItems: alignIcon }}
          >
            {icon}
          </Col>
          <Col xs={9} sm={{ span: 'auto' }}>
            <Text bold color="#000" size={isDesktop ? 16 : 14}>
              {title}
            </Text>
            <Text size="14px" color="#000">
              {description}
            </Text>
            {props.children}
          </Col>
        </Row>
      </Loading>
    </div>
  )
}

Media.propTypes = {
  loading: PropTypes.bool,
  alignIcon: PropTypes.oneOf(['flex-start', 'center', 'baseline', 'flex-end']),
  round: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.node,
}

Media.defaultProps = {
  loading: false,
  round: false,
  alignIcon: 'flex-start',
  title: '',
  description: '',
  className: '',
  onClick: null,
  children: null,
  icon: null,
}

export default Media
